module.exports = __webpack_public_path__ + "media/images/claim_box_1_image-0a69e8a2142d5b653dacdc5958db374a.png";